// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ContestPosts__list":"sp_a bho_rc bho_qx bho_xr","ContestPosts__more":"sp_b bho_vu bho_b bho_va bho_sv"};